export default "__VITE_ASSET___3v$gvMy__"